import styled from "styled-components";


export const PageMainContainer = styled.section`
  margin: 10px 10px 0 10px;
  display: flex;
  gap: 10px;
  justify-content: center
  
`

export const PageMainArticle = styled.article`
    display: flex;
  flex-direction: column;
  cursor: pointer;
  padding: 10px;
  border-radius: 15px;
  border: 1px solid black;
  &:hover {
    background: rgba(246, 238, 229, 0.5);
  }
  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
    max-height: 150px;
    max-width: 150px;
  }
  

  @media (max-width: 760px) {
    &:hover {
      background: transparent;
    }
    cursor: none;
    img {
      max-height: 100px;
      max-width: 100px;
    }
  }
`

export const PageMainText = styled.p`
    margin: 0;
  padding: 0;
  align-self: center;
`

